import React from 'react';

import { FormFieldGroup } from './FormFieldGroup';

export const withFormFieldGroupFormField =
  (options = {}) =>
  (BaseComponent) => {
    return ({ children, ...props }) => (
      <FormFieldGroup {...options} {...props}>
        {(groupProps) => (
          <BaseComponent
            {...options}
            {...props}
            {...groupProps}
            children={children}
          />
        )}
      </FormFieldGroup>
    );
  };

export default withFormFieldGroupFormField;
